// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hangar-usages-data-form .el-form-item.date-time-range .el-input__inner {\n  width: 30em;\n}\n.hangar-usages-data-form .el-form-item .el-input__inner {\n  width: 18em;\n}", ""]);
// Exports
module.exports = exports;
